import {IClient, TIntegration} from '@shared/interface';

/**
 * Cache provider to cache common resources throughout the app
 */
class CacheProvider {
  clients: Record<TIntegration, IClient[]> = {} as Record<TIntegration, IClient[]>;

  resetClientsByIntegration(integration: TIntegration) {
    delete this.clients[integration];
  }
}

export const cache = new CacheProvider();
